import script from "./TimeRatioReporting.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimeRatioReporting.vue?vue&type=script&lang=ts&setup=true"

import "./TimeRatioReporting.vue?vue&type=style&index=0&id=6abe3b80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6abe3b80"]])

export default __exports__